export default __webpack_public_path__ + "fb5b453d3225cc00033b5e74f81d74a9.png";